import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const GumrukluSahaCikisExcel = () => {
    return (
        <>
            <ExcelUpload
                role_name="gumruklu_sahacikis_write"
                requiredColumnsSase={[
                    "sase"
                ]}
                process_type="DOCK_EXIT"
                ExcelName={"Gümrüklü Sahadan Çıkış"}
                Title={"Gümrüklü Sahadan Çıkış"}
                exampleData={[
                    { sase: "VR3USHNS7RJ793212" },
                ]}
            />
        </>
    )
}

export default GumrukluSahaCikisExcel